import React from 'react';
import {Tooltip} from '@mui/material';


const TooltippedIcon = ({icon, title, placement}) => (
  <Tooltip title={title} placement={placement}>
    {icon}
  </Tooltip>
);
export default TooltippedIcon;